import _ from 'lodash'
import { IHubEventBasicFormState } from 'domain/feature/hub/company/events/FormWrapper/store/contracts'
import { IHubEventBasicFormFilesState } from 'domain/feature/hub/company/events/FormWrapper/file/store/contracts'
import { IAddressForm, IEventForm, IMultiFile } from 'domain/feature/hub/company/events/FormWrapper/constants'

export function extractData(
  state: IHubEventBasicFormState,
  formFilesState: IHubEventBasicFormFilesState,
  form: IEventForm[]
): void {
  _.set(state, 'isInPerson', _.get(form, '[0].content[0].value'))
  _.set(state, 'name', _.get(form, '[0].content[1].value'))
  _.set(state, 'description', _.get(form, '[0].content[2].value'))
  _.set(state, 'website', _.get(form, '[0].content[3].value'))
  _.set(state, 'startDate', _.get(form, '[0].content[7].value'))
  _.set(state, 'endDate', _.get(form, '[0].content[8].value'))
  _.set(state, 'startTime', _.get(form, '[0].content[9].value'))
  _.set(state, 'endTime', _.get(form, '[0].content[10].value'))
  _.set(state, 'isPaid', _.get(form, '[0].content[11].value'))
  _.set(state, 'ticketDescription', _.get(form, '[0].content[12].value'))
  _.set(state, 'isActive', _.get(form, '[0].content[13].value'))

  const addressForm = form[1].content[0] as IAddressForm
  state.address.id = addressForm.content.id.includes('_idAddress') || addressForm.content.id === null ? undefined : addressForm.content.id

  if (addressForm.content.fields != null) {
    state.address.name = addressForm.content.fields[0].value
    state.address.addressZipCode = addressForm.content.fields[1].value
    state.address.addressLineOne = addressForm.content.fields[2].value
    state.address.addressNumber = addressForm.content.fields[3].value
    state.address.addressLineTwo = addressForm.content.fields[4].value
    state.address.addressNeighborhood = addressForm.content.fields[5].value
    state.address.addressCity = addressForm.content.fields[6].value
    state.address.addressState = addressForm.content.fields[7].value
  }

  extractFiles(formFilesState, form, '[0].content[4].archive', 'coverImage')
  extractFiles(formFilesState, form, '[0].content[5].archive', 'homePageSlider')
  const multiFiles = form[0].content[6] as IMultiFile
  multiFiles.archives?.forEach((file, key) => {
    extractFiles(formFilesState, form, `[0].content[6].archives[${String(key)}]`, 'supportFiles')
  })
  extractRemovedFiles(formFilesState, form, '[0].content[4]')
  extractRemovedFiles(formFilesState, form, '[0].content[5]')
  extractRemovedFiles(formFilesState, form, '[0].content[6]')
}

function extractFiles(
  formFilesState: IHubEventBasicFormFilesState,
  form: IEventForm[],
  path: string,
  type: string
): void {
  const file = _.get(form, path)
  if (file === undefined) {
    return
  }

  if (!Boolean(file.isDeleted) && file.id !== undefined && Boolean(file.id.includes('_idScreen'))) {
    formFilesState.eventFiles.push({
      id: undefined,
      name: file.name,
      size: file.size,
      mimetype: file.mimetype,
      type: type,
      sourceFile: file.sourceFile
    })
  }
}

function extractRemovedFiles(formFilesState: IHubEventBasicFormFilesState, form: IEventForm[], path: string): void {
  const file = _.get(form, path)
  if (file === undefined) {
    return
  }

  if (file.removed === undefined || file.removed.length <= 0) {
    return
  }

  file.removed.forEach((removed) => {
    formFilesState.deletedEventFiles.push({
      id: removed,
      mimetype: '',
      name: '',
      size: 0,
      type: ''
    })
  })
}
